// COPIED from InGo's console/src/maps/places/categories.ts by scripts/build-places.mjs,
// its types erased: do not edit here. Change the console's file and run
//   node scripts/build-places.mjs
// source sha256 0f7b454154dee046ab01fa0b74739edf60b5321cb549e715264e090cccdba5c6
// copy sha256 c93dd5bfc8d50c96b39364cf5f115a48b521f0d6cf9fc780623b028d870e4f84
/**
 * The twenty kinds of place on InGo's maps, read from the tiles every map
 * already downloads (the live-map plan, 2 Oct 2026; cut from KangaruRide
 * `packages/passenger-core/src/poiCategories.ts`, ADR-0092 §1).
 *
 * Each maps to the values two tile schemas carry, a Lucide glyph by name, a
 * colour group and the zoom from which it is worth drawing. Kangaru's table,
 * its zooms kept; InGo's words.
 *
 * - `matches`: OpenMapTiles' `class`/`subclass` in the `poi` layer
 *   (OpenFreeMap's tiles, the development machine's).
 * - `kinds`: Protomaps' `kind` in the `pois` layer (the deployment's own
 *   tiles, `deploy/routing/tiles`: a different schema, not OpenMapTiles').
 *   The plain OpenStreetMap value, read from the tiles on 4 Oct 2026
 *   (Protomaps basemap 4.15.2 over Harare): pharmacies, ATMs and garages
 *   travel only in the zoom-15 tiles.
 *
 * **Pure data, no imports, no colours,** on purpose: the console and the
 * client app hold this same file, copied verbatim, so the office and the
 * clients see one map. What a group is painted in, how a badge is drawn and
 * how the layer is added are each side's own (the console's in
 * `tools/build-place-badges.mjs` and `layer.ts`).
 *
 * Nineteen read the `poi` source-layer; the airport reads `aerodrome_label`,
 * which OpenMapTiles keeps apart (Protomaps keeps it in `pois`, `aerodrome`).
 */

/** A colour group, not a colour: each side paints a group from its own tokens. */

/** One `class`/`subclass` pair a kind matches, with its own zoom when it needs one. */

/** One Protomaps `kind` a kind matches, with its own zoom when it needs one. */


export const PLACE_CATEGORIES                           = [
  { id: 'fuel', label: 'Petrol station', glyph: 'fuel', group: 'transport', minzoom: 14, layer: 'poi',
    matches: [{ class: 'fuel', subclass: 'fuel' }],
    kinds: [{ kind: 'fuel' }] },
  { id: 'hospital', label: 'Hospital', glyph: 'hospital', group: 'health', minzoom: 13, layer: 'poi',
    matches: [{ class: 'hospital', subclass: 'hospital' }],
    kinds: [{ kind: 'hospital' }] },
  { id: 'clinic', label: 'Clinic', glyph: 'stethoscope', group: 'health', minzoom: 15, layer: 'poi',
    matches: [{ class: 'hospital', subclass: 'clinic' }, { class: 'doctors', subclass: 'doctors' }],
    kinds: [{ kind: 'clinic' }, { kind: 'doctors' }] },
  { id: 'pharmacy', label: 'Pharmacy', glyph: 'pill', group: 'health', minzoom: 15, layer: 'poi',
    matches: [{ class: 'pharmacy', subclass: 'pharmacy' }, { class: 'shop', subclass: 'chemist' }],
    kinds: [{ kind: 'pharmacy' }, { kind: 'chemist' }] },
  { id: 'market', label: 'Market', glyph: 'store', group: 'shopping', minzoom: 14, layer: 'poi',
    matches: [{ class: 'grocery', subclass: 'marketplace' }],
    kinds: [{ kind: 'marketplace' }] },
  { id: 'supermarket', label: 'Supermarket', glyph: 'shopping-cart', group: 'shopping', minzoom: 15, layer: 'poi',
    matches: [{ class: 'grocery', subclass: 'supermarket' }],
    kinds: [{ kind: 'supermarket' }] },
  { id: 'mall', label: 'Shopping centre', glyph: 'shopping-bag', group: 'shopping', minzoom: 13, layer: 'poi',
    matches: [{ class: 'shop', subclass: 'mall' }],
    kinds: [{ kind: 'mall' }] },
  { id: 'restaurant', label: 'Restaurant', glyph: 'utensils', group: 'food', minzoom: 15, layer: 'poi',
    matches: [{ class: 'restaurant', subclass: 'restaurant' }, { class: 'fast_food', subclass: 'fast_food' }],
    kinds: [{ kind: 'restaurant' }, { kind: 'fast_food' }] },
  { id: 'cafe', label: 'Café', glyph: 'coffee', group: 'food', minzoom: 15, layer: 'poi',
    matches: [{ class: 'cafe', subclass: 'cafe' }],
    kinds: [{ kind: 'cafe' }] },
  { id: 'hotel', label: 'Hotel', glyph: 'bed', group: 'shopping', minzoom: 14, layer: 'poi',
    matches: [
      { class: 'lodging', subclass: 'hotel' },
      { class: 'lodging', subclass: 'guest_house' },
      { class: 'lodging', subclass: 'hostel' },
      { class: 'lodging', subclass: 'motel' },
    ],
    kinds: [{ kind: 'hotel' }, { kind: 'guest_house' }, { kind: 'hostel' }, { kind: 'motel' }] },
  { id: 'airport', label: 'Airport', glyph: 'plane', group: 'transport', minzoom: 9, layer: 'aerodrome_label',
    matches: [],
    kinds: [{ kind: 'aerodrome' }] },
  { id: 'bus', label: 'Bus station', glyph: 'bus', group: 'transport', minzoom: 14, layer: 'poi',
    matches: [{ class: 'bus', subclass: 'bus_station' }, { class: 'bus', subclass: 'bus_stop', minzoom: 16 }],
    kinds: [{ kind: 'bus_station' }, { kind: 'bus_stop', minzoom: 16 }] },
  { id: 'taxi', label: 'Taxi rank', glyph: 'car-taxi-front', group: 'transport', minzoom: 14, layer: 'poi',
    matches: [{ class: 'office', subclass: 'taxi' }],
    kinds: [{ kind: 'taxi' }] },
  { id: 'bank', label: 'Bank', glyph: 'landmark', group: 'money', minzoom: 15, layer: 'poi',
    matches: [{ class: 'bank', subclass: 'bank' }],
    kinds: [{ kind: 'bank' }] },
  { id: 'atm', label: 'ATM', glyph: 'banknote', group: 'money', minzoom: 16, layer: 'poi',
    matches: [{ class: 'atm', subclass: 'atm' }],
    kinds: [{ kind: 'atm' }] },
  { id: 'university', label: 'University or college', glyph: 'graduation-cap', group: 'civic', minzoom: 13, layer: 'poi',
    matches: [{ class: 'college', subclass: 'university' }, { class: 'college', subclass: 'college' }],
    kinds: [{ kind: 'university' }, { kind: 'college' }] },
  { id: 'school', label: 'School', glyph: 'school', group: 'civic', minzoom: 15, layer: 'poi',
    matches: [{ class: 'school', subclass: 'school' }, { class: 'school', subclass: 'kindergarten', minzoom: 16 }],
    kinds: [{ kind: 'school' }, { kind: 'kindergarten', minzoom: 16 }] },
  { id: 'police', label: 'Police station', glyph: 'siren', group: 'civic', minzoom: 13, layer: 'poi',
    matches: [{ class: 'police', subclass: 'police' }],
    kinds: [{ kind: 'police' }] },
  { id: 'parking', label: 'Parking', glyph: 'square-parking', group: 'transport', minzoom: 16, layer: 'poi',
    matches: [{ class: 'parking', subclass: 'parking' }],
    kinds: [{ kind: 'parking' }] },
  { id: 'garage', label: 'Garage', glyph: 'wrench', group: 'transport', minzoom: 15, layer: 'poi',
    matches: [
      { class: 'car', subclass: 'car_repair' },
      { class: 'car', subclass: 'car_parts' },
      { class: 'shop', subclass: 'motorcycle' },
    ],
    kinds: [{ kind: 'car_repair' }, { kind: 'car_parts' }, { kind: 'motorcycle' }] },
]

/** The image id a kind's badge is registered under on every map. */
export function placeBadgeId(categoryId        )         {
  return `ingo-place-${categoryId}`
}
